import 'whatwg-fetch';

import store from '../state/store';

import {
  createFetch,
  createStack,
  accept,
  auth,
  init,
  method,
  body,
  parseJSON,
  params
} from 'http-client';

const getToken = () => {
  const state = store.getState();
  const { result: user } = state.login.toJS();
  return user ? `Bearer ${user.token}` : null;
};

const commonStack = () =>
  createStack(
    accept('application/json'),
    auth(getToken()),
    init('credentials', 'same-origin'),
    parseJSON()
  );

const handleJsonFetch = async call => {
  const res = await call;
  if (res.ok === false) {
    const error = new Error(res.jsonData.message || 'An error occurred');
    error.status = res.status;
    error.jsonData = res.jsonData;
    throw error;
  }
  return res.jsonData;
};

export const getJson = async ({ path, payload }) => {
  const fetch = createFetch(commonStack(), params(payload));
  return handleJsonFetch(fetch(path));
};

export const postJson = async ({ path, payload }) => {
  const fetch = createFetch(
    commonStack(),
    method('POST'),
    body(JSON.stringify(payload), 'application/json')
  );
  return handleJsonFetch(fetch(path));
};

export const patchJson = async ({ path, payload }) => {
  const fetch = createFetch(
    commonStack(),
    method('PATCH'),
    body(JSON.stringify(payload), 'application/json')
  );
  return handleJsonFetch(fetch(path));
};

export const del = async ({ path }) => {
  const fetch = createFetch(commonStack(), method('DELETE'));
  return handleJsonFetch(fetch(path));
};

export const putJson = async ({ path, payload }) => {
  const fetch = createFetch(
    commonStack(),
    method('PUT'),
    body(JSON.stringify(payload), 'application/json')
  );
  return handleJsonFetch(fetch(path));
};



// WEBPACK FOOTER //
// ./src/api/fetch.js